import { BrowserRouter } from 'react-router-dom';
import Navigation from '@/navigation/navigation';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { getMVToken, getToken, setToken } from '@/helpers/auth';
import { useEffect } from 'react';
import { shallow } from 'zustand/shallow';
import { useClientProfileStore } from '@/store/ClientProfileStore';
import ClientProfile from '@/pages/ClientProfile';
import { useTripProfileStore } from '@/store/TripProfileStore';
import TripProfile from '@/pages/TripProfile';
import { useOperatorProfileStore } from '@/store/OperatorProfileStore';
import OperatorProfile from '@/pages/OperatorProfile';
import { useUserStore } from '@/store/Userdetails';
import { toast } from 'react-toastify';
import { buildURL } from '@/helpers/api-urls';
import { customAPI, defaultSuccessMessage } from '@/helpers';
import { setAtatusUser } from '@/helpers/atatus';
import { Permission } from '@/helpers/permissions';

function App() {
  axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;
  const { setUserData } = useUserStore(
    (state) => ({
      authenticateAndGetUserDetailsApi: state.getApi,
      setUserData: state.setUserData,
    }),
    shallow
  );
  useEffect(() => {
    if (getToken()) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${getToken()}`;
      axios.defaults.headers.common['Content-Type'] = 'application/json';
    } else {
      const token = getMVToken();
      if (token) {
        (async () => {
          const config = {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          };
          let payload = { origin: window.location.origin };
          const data = await customAPI('post', buildURL('authenticate-sso', '', '', 'MV'), payload, config);
          if (data?.responseCode === 200) {
            let isLogin = true;
            data?.responseData?.userData?.permissions?.forEach((v) => {
              if (!v.includes(Permission.VIEW_LEGS)) {
                isLogin = false;
              }
            });
            if (isLogin) {
              const user = data?.responseData?.userData?.user?.[0];
              setAtatusUser(user?.email || String(user?.id || ''));
              setUserData({ data: data });
              setToken(data?.responseData?.access_token);
              toast.success('Logged In Successfully!', defaultSuccessMessage);
              let rULR = window.location.search;
              const query = rULR.split('?')[1];
              const params = {};
              if (query) {
                const queryParams = query.split('&');
                queryParams.forEach((param) => {
                  const [ key, value ] = param.split('=');
                  params[key] = value;
                });
              }
              if (params && params.return_url) {
                window.location.href = window.location.origin + decodeURIComponent(params.return_url);
              } else {
                window.location.href = window.location.origin + '/';
              }
            }
          } else {
            window.history.pushState('', '', '/login');
          }
        })();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { openClientProfile, openData } = useClientProfileStore(
    (state) => ({
      openClientProfile: state.openClientProfile,
      openData: state.openData,
    }),
    shallow
  );
  const { openTripProfile } = useTripProfileStore(
    (state) => ({
      openTripProfile: state.openTripProfile,
    }),
    shallow
  );
  const { openOperatorProfile } = useOperatorProfileStore(
    (state) => ({
      openOperatorProfile: state.openOperatorProfile,
    }),
    shallow
  );
  return (
    <BrowserRouter>
      <Navigation></Navigation>
      {openClientProfile && <ClientProfile openData={openData} />}
      {openTripProfile && <TripProfile />}
      {openOperatorProfile && <OperatorProfile />}
    </BrowserRouter>
  );
}

export default App;
